import React, { useEffect, useState } from "react";
import { useError } from "../../../contexts/ErrorContext";
import useApi from "../../../hooks/useGaneshApi";

import { Box, Typography } from "@mui/material";
import EasyAnchorLink from "../../UI/AnchorLink";

import { GridColDef } from "@mui/x-data-grid-premium";
import GaneshDataGrid from "../../DataGrid/GaneshDataGrid";

import "../BrandMetadataReview.css";
import { renderNumberCell } from "utils/dataGrid";

interface NonOmniReviewProps {
  chain_id: string;
  country_code: string;
}

const ReviewPlacesIncorrectParent: React.FC<NonOmniReviewProps> = ({
  chain_id,
  country_code,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>([]);

  const { showError } = useError();
  const { apiRequest } = useApi();

  const columns_def: GridColDef[] = [
    {
      field: "place_name",
      headerName: "Place Name",
      description: "The name of the child place.",
      type: "string",
      width: 250,
    },
    {
      field: "parent_place_name",
      headerName: "Parent Place Name",
      description:
        "The name of the parent place associated with the child place.",
      type: "string",
      width: 250,
    },
    {
      field: "country_code",
      headerName: "Country Code",
      description: "The country code for the associated place.",
      type: "string",
      width: 150,
    },
    {
      field: "row_count",
      headerName: "Row Count",
      description:
        "The number of occurrences of this child-parent combination in the data.",
      type: "number",
      width: 150,
      renderCell: renderNumberCell,
    },
  ];

  useEffect(() => {
    if (chain_id && country_code) {
      setLoading(true);
      const params = new URLSearchParams({
        chain_id: chain_id,
        country_code: country_code,
      });

      const fetchIncorrectParent = async () => {
        try {
          const response = await apiRequest<any>(
            `/brand_metadata/wrong_combination?${params.toString()}`,
            {
              method: "GET",
            }
          );
          if (response.data) {
            setData(response.data);
          }
        } catch (error) {
          console.error(error);
          showError(
            `Failed to fetch places parent child mismatches for chain_id ${chain_id} + ${country_code}.`
          );
        } finally {
          setLoading(false);
        }
      };
      fetchIncorrectParent();
    } else {
      setData([]);
    }
  }, [chain_id, country_code]);

  return (
    <Box className="metadata-review-container">
      <Box display="flex" alignItems="center" id="incorrect-parents">
        <EasyAnchorLink id="incorrect-parents" />
        <Typography variant="h6" gutterBottom sx={{ fontSize: "1.25rem" }}>
          Check for child-parent mismatch
        </Typography>
      </Box>

      <GaneshDataGrid
        gridId="placesReviewIncorrectParent"
        columns={columns_def}
        data={data}
        loading={loading}
        headerFilters={data.length > 0 ? true : false}
        customHeight={data.length > 0 ? "750px" : "300px"}
      />
    </Box>
  );
};

export default ReviewPlacesIncorrectParent;
